import { SnackbarOrigin } from "@mui/material";

import {
  authButton,
  authLink,
  authSmallText,
  colors,
  inputHint,
} from "../../theme";

const styles = {
  alert: {
    width: '100%',
  },
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  } as SnackbarOrigin,
  linkTextDecoration: authLink,
  smallText: authSmallText,
  smallLink: {
    ...authSmallText,
    fontWeight: 700,
    color: colors.text,
  },
  hint: {
    ...inputHint,
    color: colors.textSecondary,
  },
  cguText: {
    ...authSmallText,
    fontSize: 12.5,
    fontWeight: 400,
    pl: '1%',
    lineHeight: 1.5,
  },
  signupButton: authButton,
}

export default styles;
